<template>
    <v-speed-dial
        v-model="fab"
        absolute
        :open-on-hover="false"
        :direction="$vuetify.breakpoint.smAndDown ? 'bottom' : 'left'"
        :transition="
            $vuetify.breakpoint.smAndDown
                ? 'slide-y-transition'
                : 'slide-x-transition'
        "
    >
        <template v-slot:activator>
            <v-btn v-model="fab" icon>
                <v-icon large>
                    {{
                        $vuetify.breakpoint.smAndDown
                            ? 'mdi-dots-horizontal'
                            : 'mdi-dots-vertical'
                    }}
                </v-icon>
            </v-btn>
        </template>
        <v-btn fab color="blue" @click="openModHeadersTableDialog">
            <v-icon color="white">mdi-pencil</v-icon>
        </v-btn>
        <v-btn
            v-if="hasSuperAdminPermission"
            fab
            dark
            color="indigo"
            @click="crearCuentaDialogo"
        >
            <v-icon large>mdi-plus</v-icon>
        </v-btn>
        <!-- <v-btn
            v-if="clicksToTenant >= 7 && hasSuperAdminPermission"
            fab
            dark
            color="purple"
            @click="newTenant()"
        >
            <v-icon large>mdi-briefcase-account-outline</v-icon>
        </v-btn> -->
        <v-btn
            v-if="clicksToTenant >= 7 && hasSuperAdminPermission"
            fab
            dark
            color="red"
            @click="openCredentialsManagement()"
        >
            <v-icon large>mdi-key-star</v-icon>
        </v-btn>    
        <v-btn 
            color="orange" 
            fab 
            dark
            @click="openCommunicateManagement()"
        >
            <v-icon large> mdi-notebook-edit </v-icon>
        </v-btn>
        <v-btn
            v-if="hasSuperAdminPermission"
            color="green"
            fab
            dark
            @click="openSpreadsheetForm"
        >
            <v-icon large> mdi-microsoft-excel </v-icon>
        </v-btn>
    </v-speed-dial>
</template>
<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'Dial',
    data: () => ({
        fab: false,
    }),
    methods: {
        openModHeadersTableDialog() {
            this.$store.commit('gerencia/isOpenModHeadersDialog', true);
        },
        crearCuentaDialogo() {
            this.$store.dispatch('rrhh/openNuevaCuentaDialogo');
        },
        queryComerciales() {
            this.$store.dispatch('gerencia/openComercialesTableFilterDialog');
        },
        newTenant() {
            this.$store.commit('tenantManagement/openNewTenantDialog', true);
        },
        openSpreadsheetForm() {
            this.$store.commit('util/isOpenDownloadTemplateAndUpload', true);
        },
        openCredentialsManagement() {
            this.$store.commit('rrhh/isOpenCredentialsSummary', true);
        },
        openCommunicateManagement() {
            this.$store.commit('rrhh/isOpenCommunicatesSummary', true);
        },
    },  
    computed: {
        ...mapState('rrhh', {
            clicksToTenant: (state) => state.clicksToTenant,
        }),
        ...mapGetters('login', {
            hasAdminPermission: 'hasAdminPermission',
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
    },
};
</script>